module.exports = __webpack_public_path__ + "img/ethereum.4cdfd359.png";